import { Routes, BrowserRouter as Router, Route } from 'react-router-dom';

import Email from '../Pages/email';
import Senha from '../Pages/senha';


export default function RouteApp (){

    return(
        <Router>
            <Routes>
                <Route path={`/`} element={<Email/>} />
                <Route path={`/RedefinirSenha`} element={<Senha/>}/>
            </Routes>
        </Router>
    )
} 